// WO-2929: the signed-in person's own app memberships (RLS lets a person read only their own row). Returns null until known, [] when there are none or the table is not there yet,
// which is the unchanged pre-WO-2929 behaviour.
import { useEffect, useState } from 'react';
import { supabase } from './supabase';
import { appAccess } from './appIdentity';

export default function useAppMemberships(userId) {
  const [memberships, setMemberships] = useState(null);
  useEffect(() => {
    if (!userId) { setMemberships(null); return undefined; }
    let live = true;
    Promise.resolve(supabase.from('app_memberships').select('app_key, roles, is_active').eq('user_id', userId))
      .then(({ data, error }) => { if (live) setMemberships(error || !Array.isArray(data) ? [] : data); })
      .catch(() => { if (live) setMemberships([]); });
    return () => { live = false; };
  }, [userId]);
  return memberships;
}

// The signed-in person's GenServ access ({ scope, roles }) for the Owner-only screen guards. null while loading; anything unreadable resolves to legacy (unchanged behaviour).
export function useGenservAccess() {
  const [access, setAccess] = useState(null);
  useEffect(() => {
    let live = true;
    (async () => {
      try {
        const { data: auth } = await supabase.auth.getUser();
        const uid = auth && auth.user && auth.user.id;
        if (!uid) { if (live) setAccess({ scope: 'legacy', roles: [] }); return; }
        const { data, error } = await supabase.from('app_memberships').select('app_key, roles, is_active').eq('user_id', uid);
        if (live) setAccess(error || !Array.isArray(data) ? { scope: 'legacy', roles: [] } : appAccess(data, 'genserv'));
      } catch { if (live) setAccess({ scope: 'legacy', roles: [] }); }
    })();
    return () => { live = false; };
  }, []);
  return access;
}
